import { Injectable, inject, signal, computed } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ATTACHMENTS_HANDLER_CONFIG } from '../config/attachments-handler.config';
import { UserData } from '../models/api/api-responses.model';


@Injectable({
    providedIn: 'root',
})
export class UserMetaDataService {
    private readonly http = inject(HttpClient);
    private readonly baseUrl = inject(ATTACHMENTS_HANDLER_CONFIG).apiUrl;

    private readonly _userData = signal<UserData | null>(null);

    readonly userName = computed(() => this._userData()?.name ?? '');

    load(): void {
        this.http.get<UserData>(`${this.baseUrl}configuration/user`).subscribe({
            next: (data) => this._userData.set(data),
            error: (err) => console.error('Failed to load user data:', err),
        });
    }
}
